import { Global } from "@/helpers/global";
import { validationMixin } from "../../../mixins/validationMixin.js";
import { ApiService } from "@/helpers/apiService";
export const propertyTracking = {
  props: ["userPermissionDataProps"],
  mixins: [validationMixin],
  data() {
    return {
      // Data Table
      tableLoadingDataText: "Loading data",
      tableHeader: [
        {
          text: "#",
          value: "index",
          width: "5%",
          sortable: false,
          align: "start",
        },
        {
          text: "Property Name",
          value: "property_name",
          width: "15%",
          sortable: true,
          align: "start",
        },
        {
          text: "Date First",
          value: "date_first_added",
          sortable: true,
          width: "10%",
          align: "start",
        },
        {
          text: "Date Last",
          value: "date_last_modified",
          sortable: true,
          width: "10%",
          align: "start",
        },
        {
          text: "Status Change",
          value: "date_last_status_change",
          sortable: true,
          width: "10%",
          align: "start",
        },
        {
          text: "Date Suspended",
          value: "date_suspended",
          sortable: false,
          width: "10%",
          align: "start",
        },
        {
          text: "User Type",
          value: "user_type",
          sortable: false,
          width: "10%",
          align: "start",
        },

        {
          text: "Date Operator",
          value: "date_modified_operator",
          sortable: false,
          width: "10%",
          align: "start",
        },
        {
          text: "Operator Name",
          value: "operator_name",
          sortable: false,
          width: "15%",
          align: "start",
        },
      ],
      tableItems: [],
      totalItemsInDB: 0,
      tableDataLoading: false,

      show: true,
      isLoaderActive: false,
      pagination: {},
      module: "Reports",
      entity: "Property Tracking",

      date_sold_from_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      menu_date_sold_from_date: false,

      date_sold_to_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      menu2_date_sold_to_date: false,

      // search
      searchText: "",

      //excel
      excelFields: {
        propertyName: "property_name",
        DateFirstAdded: "date_first_added",
        DateLastModified: "date_last_modified",
        DateLastStatusChange: "date_last_status_change",
        DateSuspended: "date_suspended",
        ModifiedBy: "user_type",
        DateModifiedByOperator: "date_modified_operator",
        OperatorName: "operator_name",
      },
      excelFileName: "Tracking" + moment().format("DD/MM/YYYY") + ".xls",
      //end
    };
  },
  //#region created
  created() {
    // To get Details in List
    this.getDetails();
  },
  //#endregion

  //#region computed
  computed: {
    // For numbering the Data Table Rows
    dataTableRowNumbering() {
      return this.tableItems.map((items, index) => ({
        ...items,
        index: index + 1,
      }));
    },
  },
  //#endregion

  //#region watch
  watch: {
    pagination: {
      handler() {
        this.getDetails();
      },
      deep: true,
    },
  },
  //#endregion
  //#region methods
  methods: {
    //#region To get the Details list
    getDetails() {
      this.isLoaderActive = true;
      let { page, itemsPerPage, sortDesc, sortBy } = this.pagination;
      sortDesc = sortDesc.length > 0 && sortDesc[0] ? "desc" : "asc";
      sortBy = sortBy.length == 0 ? `date_first_added` : sortBy[0];
      ApiService.get("getPropertyTrackingReport", {
        from_date: this.date_sold_from_date,
        to_date: this.date_sold_to_date,
        itemsPerPage: itemsPerPage,
        sortColumn: sortBy,
        sortOrder: sortDesc,
        page: page,
        searchText: this.searchText,
      })
        .then((response) => {
          console.log(response);
          this.isLoaderActive = false;
          this.tableItems = response.data.resultData.data;
          this.totalItemsInDB = response.data.resultData.total;
        })
        .catch((error) => {
          this.isLoaderActive = false;
          if (error.response.status != 401 || error.response.status != 403) {
            Global.showErrorAlert(true, "error", "Something went wrong");
          }
        });
    },
    //#endregion

    //#region searchInfo
    searchInfo() {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        this.getDetails();
      }, 500);
    },
    //#endregion
  },
  //#endregion
};
